import { useState, useEffect } from "react";
import N from "../../assets/N.png";
// import ORTH from "../../assets/orth.png";
import ArrowBtn from "../../components/ArrowBtn";
import styles from "../../styles/pagesStyles/homePage.module.css";
import { Link } from "react-router-dom";
import home_grid_1 from "../../assets/home/home_grid_1.jpg";
// import quote from "../../assets/home/quote.png";
// import TrailImage from "../../components/TrailImage";
import { FadeType } from "../../animation/Animation";
import FooterWithContactUs from "../../components/FooterWithContactUs";
import Navbar from "../../components/Navbar";
import useBreakpoints from "../../customHook/useBreakpoints";
import gsap from "gsap";
import image1 from "../../assets/press/1.jpg";

import MobAppBar from "../../components/MobAppBar";
import homepageStay from "../../assets/home/HOMEPAGE_stay.jpg";
import homepageWorkshop from "../../assets/home/HOMEPAGE_workshops.jpg";
import intro_video from "../../assets/home/intro.mp4"

const imageList = [home_grid_1, homepageStay, homepageWorkshop];

const testimonialData = [
    {
        type: "architecture",
        id: 1,
        head: "Shri Jairam Thakur",
        body1: "अपनी धरोहर को ज़िन्दा रखने के लिए बहुत बहतरीन प्रयास। काठकुनी एक पूरानी मकान बनाने की शैली है जो खत्म होती जा रही है।इसको ज़िन्दा रखने का बेहतरीन प्रयास है।",
        body2: "प्रयास के लिए राहुल को शुभकामनाएँ।",
        body3: "A great attempt at keeping your heritage alive. Kathkuni is an old building style that is dying out. It is a wonderful effort to keep it alive.",
        body4: "Best wishes to Rahul for the cause.",
        name: "Shri Jairam Thakur",
        caption1: "Chief Minister, Himachal Pradesh",
        // caption2: "adipiscing elit",
    },
    {
        type: "architecture",
        id: 2,
        head: "Raas project",
        body1: "Working with NORTH has been a wonderful experience. Their vision of bringing back the traditional architecture and combining it with modern comfort and techniques is a step forward for the Himachali architecture. They play wonderfully with different elements and have a great aesthetic sense of a building. The whole team is very dedicated and hardworking. They are one of the most unique design studios coming out of Himachal.",
        name: "Raas project",
        caption1: "Client",
        // caption2: "adipiscing elit",
    },
    {
        type: "architecture",
        id: 3,
        head: "Riya Singh",
        body1: "NORTH has given me an experience, wisdom and learning of a lifetime. I had joined the team as an Urban Design intern, and working on the same with a complete different context had opened a box handful of possibilities and opportunities. The warmth of the people, the aura of the place and the limitless vision is what kept me going to explore the possibilities and extent of the profession.",
        name: "Riya Singh",
        caption1: "Intern",
        // caption2: "adipiscing elit",
    },
    {
        type: "workshop",
        id: 4,
        head: "Parul Dhiman",
        name: "Parul Dhiman",
        caption1: "Architect",
        body1: "Thank you so much for this great initiative to bring us all together.. the sessions were very thoughtful and well organised. Kudos to you and your team. I had a lovely experience and hope to explore more about such practices. Gratefully.",
    },
    {
        type: "workshop",
        id: 5,
        head: "Aishwarya Kulkarni",
        name: "Aishwarya Kulkarni",
        caption1: "Architect",
        body1: "Thank you for this very introspective workshop. Coming from a city, I feel every time I look at a building now, I am going to question it's sustainability quotient, and wonder if it could be made in more vernacular and material-effective manner. I really enjoyed knowing these techniques and materials in such depth as they give confidence to us, as designers and architects to be less redundant when it comes to building materials and technologies. Thank you again, for this workshop! I wish you, and the firm all the best. And hope more architects and clients are more aware and sensitive while building a home. :)",
    },
    {
        type: "workshop",
        id: 6,
        head: "Alisha Bhutada",
        name: "Alisha Bhutada",
        caption1: "Architecture student",
        body1: "Thank you so much Rahul Sir. The workshop has been really interesting and informative. Has opened up a lot of new fields to explore in matter of natural building. Also, glad to connect with you all.",
    },
    {
        type: "stay",
        id: 7,
        head: "Simone",
        name: "Simone",
        caption1: "A-frame Cabin",
        body1: "An artists and nature lovers dream. We were super excited about the Dhajji House and it exceeded all our expectations. A beautifully built sustainable cabin with everything we could need. Not only was the view stunning in the day but the stars from the cabin were gorgeous too. The cabin offers tranquility while still being walking distance from cafés, local shops and naggar castle. Everyone at north was super sweet and welcoming and made us feel right at home. A special Tirath who was always a call away and helped us with everything we needed from hiring bikes to setting up wood for a bonfire. Definitely worth the experience. I would love to go back again",
    },
    {
        type: "stay",
        id: 8,
        head: "Kshitij",
        name: "Kshitij",
        caption1: "A-frame Cabin",
        body1: "Had a fantastic time at North and cannot wait to come back again. The dhajji has been made with a lot of love and Rahul’s team at North has put a lot of heart into building the place. And they continue to do so and are always looking for suggestions to make the place better. My day started with Pooranji’s chai and ended with long chats with the folks from the studio. Atal, Dwija and everyone else were a lot of fun to hang out with! Naggar is quieter than most commercial spots and you can go for quick hikes to lots of villages nearby. Or if the day is colder, just sit in the Dhajji on the sun deck and just paint/read for hours. Was in need of a break for a long time and I’m glad I chose to come here. ♥",
    },
    {
        type: "stay",
        id: 9,
        head: "Sharmistha",
        name: "Sharmistha",
        caption1: "A-frame Cabin",
        body1: "It was a delight staying at this property! The cabin is pretty spacious and secluded (from a privacy point of view) and has amazing views to offer. There are a lot of cafes and local shops around so if you feel like stepping down to buy essentials you won’t have to walk a lot. In fact, the Naggar castle is only a 5-mins walk from this property! The kitchen is well equipped with all necessary condiments - so you can get fresh veggies from the local market downstairs and cook your own food! The hosts are very warm and Tirath will be there to help with anything you need. The wifi speed is excellent so you can actually consider this for a workation!",
    },
    {
        type: "experience",
        id: 10,
        head: "Priyanka Tehri",
        name: "Priyanka Tehri",
        caption1: "Mindful Retreat",
        // subhead: "consectetur adipiscing elit adipiscing elit",
        body1: "Amazing hospitality by our host ‘NORTH’. A must visit place to experience the beauty of nature, meeting amazing people. Will surely visit again😊",
    },
    {
        type: "experience",
        id: 11,
        head: "Abdullahsaghirahmad",
        name: "Abdullahsaghirahmad",
        caption1: "Mindful Retreat",
        // subhead: "consectetur adipiscing elit adipiscing elit",
        body1: "If you are looking for a place to connect with yourself, tap into your creative self, or live in a space where modern ways of living meet the traditional and conscious ways, North is your go-to place. Here's my complete experience: https://www.tripoto.com/trip/i-travelled-for-a-mindful-retreat-in-the-mountains-experienced-something-like-never-before-3aeda5f78368242b1",
    },
    {
        type: "experience",
        id: 12,
        head: "Saloni Tehri",
        name: "Saloni Tehri",
        caption1: "Mindful Retreat",
        // subhead: "consectetur adipiscing elit adipiscing elit",
        body1: "Located amidst the serene valley of Kullu, Himachal Pradesh, NORTH is a home away from home! It is the epitome of slow-living with the beauty of nature where you are guaranteed to have a great time. The place and the people are super warm and welcoming. I had a wonderful time with the hosts, met new people and had an experience of a lifetime. If you're anywhere near Kullu Manali, do make sure to visit the amazing people there and experience this beautiful place! :)",
    },
    // {
    //     type: "shop",
    //     id: 10,
    //     head: "Lorem Ipsum",
    //     body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    //     name: "Testimonial 10",
    //     caption1: "consectetur adipiscing elit",
    //     caption2: "adipiscing elit",
    // },
    // {
    //     type: "shop",
    //     id: 11,
    //     head: "Lorem Ipsum",
    //     body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    //     name: "Testimonial 11",
    //     caption1: "consectetur adipiscing elit",
    //     caption2: "adipiscing elit",
    // },
    // {
    //     type: "shop",
    //     id: 12,
    //     head: "Lorem Ipsum",
    //     body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    //     name: "Testimonial 12",
    //     caption1: "consectetur adipiscing elit",
    //     caption2: "adipiscing elit",
    // },
];

const gridData = [
    {
        image: home_grid_1,
        head: "Architecture Studio",
        body: "We practice indigenous building systems in the western Himalayas by seeking to learn the rules of the past and breaking them by tapping into the deepest potential of a material.",
        footer: "Our Projects",
        link: "/architecture",
    },
    {
        image: homepageStay,
        head: "Stay & Experiences",
        body: "To understand a simple life, one has to live it. We strive towards a more self reliant way of living, getting back to our roots. Roots, not of our state or country of birth, but our roots as a human being.",
        footer: "Experience life at North",
        link: "/properties",
    },
    {
        image: homepageWorkshop,
        head: "Workshops",
        body: "To gain an insight, one has to inspire curiosity and perseverance in their own self, only then can we begin to truly learn.",
        footer: "Learn from a skilled craftsperson",
        link: "/workshops",
    },
];

const newsroomData = [
    {
        head: "This CEPT Alumnus Is Reviving A 1200-YO Architecture Form That Can Last Upto 5 Centuries",
        body: "Rahul Bhushan, a native of Himachal, is working to preserve Kath Kuni through his venture, NORTH. Kath Kuni is an ancient form of architecture that is earthquake resistant and eco-friendly.",
        buttonText: "Read More",
        date: "March 03, 2021",
        article: "Better India",
        link: "https://www.thebetterindia.com/250285/rahul-bhushan-himachal-firm-north-preserving-reviving-kath-kuni-ancient-architecture-earthquake-resistant-eco-friendly-gop94/",
    },
    {
        image: image1,
        type: "video",
        head: "A young architect restores the glory of these majestic wood and stone buildings of Himachal Pradesh",
        body: "",
        buttonText: "Watch Now",
        date: "Jul 21, 2019",
        article: "Down to earth magazine",
        link: "https://www.youtube.com/watch?v=jSyuMssVPSM",
    },
    {
        head: "Saving tradition and promoting village tourism",
        body: "Thanks to the rain, it's cold and dark in here, in my 1 BHK apartment. I have slowed down the ceiling fan, which means it makes an annoying yank yank noise. My eyes are tired, looking at the laptop screen. I curse the founders of WhatsApp for robbing off whatever little peace the corporate employees seemed to have in the past few years.",
        buttonText: "Read More",
        date: "Aug 20, 2020",
        article: "The Tribune",
        link: "https://www.tripoto.com/mumbai/trips/wfh-work-from-a-himachali-home-admist-the-company-of-deodar-trees-5f474b1208ea3",
    },
];

const HomePageComp = () => {
    const { isTm, isMd, isXl, isXs } = useBreakpoints();

    // const [imageHover, setImageHover] = useState(false)
    // const [checkBoxValue, setCheckBoxValue] = useState(false);

    const [index, setIndex] = useState(0);
    const [hover, setHover] = useState(false);

    const [testimonialId, setTestimonialId] = useState(testimonialData[0].id);

    const [testimonialType, setTestimonialType] = useState(
        testimonialData[0].type
    );

    const showLogoAnimate = () => {
        gsap.fromTo(
            "#orthLogo",
            { autoAlpha: 0, x: -70 },
            { autoAlpha: 1, x: 0, duration: 0.6 }
        );
    };
    const hideLogoAnimate = () => {
        gsap.fromTo(
            "#orthLogo",
            { autoAlpha: 1, x: 0 },
            { autoAlpha: 0, x: -70, duration: 0.6, delay: 1 }
        );
    };

    useEffect(() => {
        hideLogoAnimate();
    }, [isMd]);

    const handleClickTestimonial = (data) => {
        setTestimonialType(data);
        let type = testimonialData.filter(val => val.type === data);
        setTestimonialId(type[0].id)
        setIndex(type[0].id - 1)
    }

    const previousIndexTestimonial = () => {
        if (index > 0) {
            setIndex(index - 1);
            setTestimonialId(testimonialData[index - 1].id);
            setTestimonialType(testimonialData[index - 1].type);
        }
        else {
            setIndex(testimonialData.length - 1);
            setTestimonialId(testimonialData[testimonialData.length - 1].id);
            setTestimonialType(testimonialData[testimonialData.length - 1].type);
        }
    }
    const nextIndexTestimonial = () => {
        if (index < testimonialData.length - 1) {
            setIndex(index + 1);
            setTestimonialId(testimonialData[index + 1].id);
            setTestimonialType(testimonialData[index + 1].type);
        }
        else {
            setIndex(0);
            setTestimonialId(testimonialData[0].id);
            setTestimonialType(testimonialData[0].type);
        }
    }

    useEffect(() => {
        // if (!isTm) {
        if (hover) return;
        else {
            const interval = setInterval(() => {
                if (index < testimonialData.length) {
                    setIndex(index + 1);
                    setTestimonialId(testimonialData[index].id);
                } else {
                    setIndex(0);
                    setTestimonialId(testimonialData[0].id);
                }
            }, 2500);
            if (isTm) {
                clearInterval(interval)
            }
            return () => clearInterval(interval);
        }
        // }
    }, [index, hover, isTm]);

    const [formData, setFormData] = useState({
        name: "",
        mobileNo: "",
        email: "",
        helpMessage: "",
        // subscription: checkBoxValue,
    });

    const { name, email, helpMessage, mobileNo } = formData;

    const [error, setError] = useState({
        errorId: "",
        errorFlag: false,
        message: "",
    });

    const { errorId, errorFlag, message } = error;

    function isObjectEmpty() {
        for (var key in formData) {
            if (formData[key] === null || formData[key] === "")
                return {
                    empty: true,
                    id: key,
                };
        }
        return {
            empty: false,
        };
    }

    const formValidator = () => {
        const check = isObjectEmpty();
        if (check.empty) {
            setError({
                errorId: check.id,
                errorFlag: true,
                message: `Please fill your ${check.id}`,
            });
            return false;
        } else if (mobileNo.length !== 10) {
            setError({
                errorId: "mobileNo",
                errorFlag: true,
                message: "Invalid Phone Number! It must be 10 Digits",
            });
            return false;
        } else if (
            !/^[a-zA-Z0-9_]+(?:\.[a-zA-Z0-9]+)*@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/gm.test(
                email
            )
        ) {
            setError({
                errorId: "email",
                errorFlag: true,
                message: "Invalid Email ID, Please enter valid email Id",
            });
            return false;
        } else if (helpMessage.length <= 50) {
            setError({
                errorId: "helpMessage",
                errorFlag: true,
                message:
                    "We don't judge, elaborate your problem and I will come to rescue",
            });
            return false;
        } else {
            setError({
                errorId: "",
                errorFlag: false,
                message: "",
            });
            return true;
        }
    };
    const handleFormDataChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // formData.subscription = checkBoxValue;
        if (formValidator()) {
            console.log("no error");
            console.log(formData);
        }
    };

    // useEffect(() => {
    //     var video = document.getElementById('testvideo')

    //     // When the 'ended' event fires
    //     video.addEventListener('ended', function () {
    //         // Reset the video to 0
    //         video.currentTime = 0;
    //         // And play again
    //         video.play();
    //     });
    // }, [])

    return (
        <>
            <div id="Home_Page" className={styles.home_container}>
                {isMd ? (
                    <MobAppBar />
                ) : (
                    <>
                        <Navbar />
                        <div
                            className={styles.home_component_header}
                            onMouseEnter={() => showLogoAnimate()}
                            onMouseLeave={() => hideLogoAnimate()}
                        >
                            <div className={styles.header_logo}>
                                <Link
                                    id="fixedHomeLink"
                                    to={"/home"}
                                    className={styles.header_logo}
                                >
                                    <img
                                        src={N}
                                        alt="logo"
                                        className="n_logo"
                                        loading="lazy"
                                    />
                                    <div id="orthLogo" className={styles.orth_logo}>
                                        ORTH
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </>
                )}
                {isXl ?
                    <div className={`${styles.home_section___one} ${styles.mob}`}>
                        <FadeType wrapperElement="h2" type="left">
                            Who we are.
                        </FadeType>
                        <div className={styles.intro_video}>
                            <video autoPlay={true} muted loop playsInline>
                                <source src={intro_video} />
                            </video>
                        </div>
                        <div className={styles.intro_grid}>
                            <FadeType wrapperElement="p" type="right">
                                North is a land where anything is possible,
                                life is easy and fun. It is a quiet place in the
                                woods, somewhere where we feel free, live
                                amongst splendid nature, make architecture,
                                design, art and food.
                            </FadeType>
                            <FadeType wrapperElement="p" type="left">
                                We are a creative studio that flourishes the
                                local craft of our region as we research and
                                innovate on sustainable architecture, make
                                eco homes, practice permaculture and share
                                this knowledge through workshops. Read that
                                again.
                            </FadeType>
                            <FadeType wrapperElement="p" type="right">
                                We are here to redefine living in the 21st
                                century through the means of what we know
                                best - design. At the precipice of losing
                                the very diversity that makes us different,
                                all to the metronome of globalization, we
                                are gathering for a movement through
                                creation.
                            </FadeType>
                        </div>
                        <FadeType type="down" className={styles.grid_btn}>
                            <Link to={"/about"} className="normal_btn___dark">
                                More About Us
                            </Link>
                        </FadeType>
                    </div>
                    :
                    <div className={styles.home_section___one}>
                        <FadeType wrapperElement="h2" type="left">
                            Who we are.
                        </FadeType>
                        <div className={styles.trail_cont}>
                            <div className={styles.intro_grid}>
                                <FadeType wrapperElement="p" type="right">
                                    North is a land where anything is possible,
                                    life is easy and fun. It is a quiet place in the
                                    woods, somewhere where we feel free, live
                                    amongst splendid nature, make architecture,
                                    design, art and food.
                                </FadeType>
                                <FadeType wrapperElement="p" type="left">
                                    We are a creative studio that flourishes the
                                    local craft of our region as we research and
                                    innovate on sustainable architecture, make
                                    eco homes, practice permaculture and share
                                    this knowledge through workshops. Read that
                                    again.
                                </FadeType>
                                <FadeType wrapperElement="p" type="right">
                                    We are here to redefine living in the 21st
                                    century through the means of what we know
                                    best - design. At the precipice of losing
                                    the very diversity that makes us different,
                                    all to the metronome of globalization, we
                                    are gathering for a movement through
                                    creation.
                                </FadeType>
                            </div>
                            <div className={styles.intro_video}>
                                <video autoPlay={true} muted loop playsInline>
                                    <source src={intro_video} />
                                </video>
                            </div>
                        </div>
                        <FadeType type="down">
                            <Link to={"/about"} className="normal_btn___dark">
                                More About Us
                            </Link>
                        </FadeType>
                    </div>
                }
                <div className={styles.home_section___second}>
                    <FadeType type="left">
                        <h2>
                            What we do.
                        </h2>
                    </FadeType>
                    <div className={styles.card_grid___container}>
                        {gridData.map((val, index) => (
                            <FadeType type="up" className={styles.card_container} key={index}>
                                <Link to={val.link} className={styles.card_image}>
                                    <FadeType wrapperElement="img" type="up" src={val.image} alt="Home_Card_Image" loading="lazy" />
                                </Link>
                                <div className={styles.card_content}>
                                    <FadeType wrapperElement="h3" type="up">
                                        {val.head}
                                    </FadeType>
                                    <FadeType wrapperElement="p" type="up">
                                        {val.body}
                                    </FadeType>
                                    <FadeType type="up">
                                        <Link to={val.link}>
                                            <h4>{val.footer}</h4>
                                        </Link>
                                    </FadeType>
                                </div>
                            </FadeType>
                        ))}
                    </div>
                </div>
                <div className={styles.home_section___third}>
                    <FadeType type="left">
                        <Link to="/press">
                            <h2>Where stories are born.</h2>
                        </Link>
                    </FadeType>
                    <FadeType type="left" delay={0.2}>
                        <Link to="/press">
                            <h3>Newsroom</h3>
                        </Link>
                    </FadeType>
                    <div className={styles.news_grid}>
                        {newsroomData.map((val, index) => (
                            <a href={val.link} target="_blank" rel="noopener noreferrer">
                                <div className={styles.news_card} key={index}>
                                    <FadeType type="up">
                                        <h4>
                                            {val.head.length <= 60 ? val.head : val.head.substring(0, 60) + ".."}
                                        </h4>
                                    </FadeType>
                                    {val.type === "video" ? (
                                        <div className={styles.press_image}>
                                            <img src={val.image} alt="" loading="lazy" />
                                        </div>
                                    ) : (
                                        <FadeType type="down" delay={0.2}>
                                            <p>{val.body.length <= 200 ? val.body : (val.body.substring(0, 200) + "..")}</p>
                                            {/* <p>{val.body}</p> */}
                                        </FadeType>
                                    )}
                                    <FadeType type="down" delay={0.3}>
                                        <a
                                            href={val.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {val.buttonText}
                                        </a>
                                    </FadeType>
                                    <div className={styles.news_card___footer}>
                                        <FadeType type="down" delay={0.4}>
                                            <p>{val.date}</p>
                                        </FadeType>
                                        <FadeType type="down" delay={0.4}>
                                            <h6>{val.article}</h6>
                                        </FadeType>
                                    </div>
                                </div>
                            </a>
                        ))}
                    </div>
                    <FadeType type="down" delay={1}>
                        <Link
                            to={"/press"}
                            className={`normal_btn___light ${styles.news_button}`}
                        >
                            View All
                        </Link>
                    </FadeType>
                </div>
                <div className={styles.home_section___four}>
                    <FadeType type="left">
                        <h2>What people say about us</h2>
                    </FadeType>
                    <FadeType type="right">
                        <h3>Testimonials</h3>
                    </FadeType>
                    {isTm ? (
                        <>
                            <div className={styles.testimonial_category___mob}>
                                <div className={styles.mob_testimonial_column_1}>
                                    <div className={testimonialType === "architecture" ? styles.mob_hover : undefined}>
                                        <h4 onClick={() => handleClickTestimonial("architecture")}>
                                            Architecture
                                        </h4>
                                    </div>
                                    <div className={testimonialType === "experience" ? styles.mob_hover : undefined}>
                                        <h4 onClick={() => handleClickTestimonial("experience")}>
                                            Experiences
                                        </h4>
                                    </div>
                                </div>
                                <div className={styles.mob_testimonial_column_2}>
                                    <div className={testimonialType === "workshop" ? styles.mob_hover : undefined}>
                                        <h4 onClick={() => handleClickTestimonial("workshop")}>
                                            Workshop
                                        </h4>
                                    </div>
                                    <div className={testimonialType === "stay" ? styles.mob_hover : undefined}>
                                        <h4 onClick={() => handleClickTestimonial("stay")}>
                                            Stay
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.testimonial_mob___quote_container}>
                                {testimonialData
                                    .filter((val) => val.id === testimonialId && val.type === testimonialType)
                                    .map((val, index) => (
                                        <FadeType type="left" key={val.id} className={styles.testimonial_quote___mob}>
                                            <p>
                                                {val.body1}
                                                {val.body2 && <>
                                                    <br />
                                                    <br />
                                                    {val.body2}
                                                </>}
                                                {val.body3 && <>
                                                    <br />
                                                    <br />
                                                    {val.body3}
                                                </>}
                                                {val.body4 && <>
                                                    <br />
                                                    <br />
                                                    {val.body4}
                                                </>}
                                            </p>
                                        </FadeType>
                                    ))}
                                {testimonialData
                                    .filter((val) => val.id === testimonialId && val.type === testimonialType)
                                    .map((val, index) => (
                                        <div className={styles.testimonial_author___mob} key={val.id}>
                                            <FadeType type="right">
                                                <h4>{val.name}</h4>
                                            </FadeType>
                                            <FadeType type="down" delay={0.1}>
                                                <p>{val.caption1}</p>
                                            </FadeType>
                                            {/* <FadeType type="down">
                                                <p>{val.caption2}</p>
                                            </FadeType> */}
                                        </div>
                                    ))}
                            </div>
                            <div className={styles.testimonial_slider_home}>
                                <ArrowBtn isDark isLeft={true} btnClickFunction={previousIndexTestimonial} />
                                <ArrowBtn isDark btnClickFunction={nextIndexTestimonial} />
                            </div>
                        </>
                    ) : (
                        <>
                            <div className={styles.testimonial_grid} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
                                <div className={styles.testimonial_box}>
                                    <FadeType type="up">
                                        <h4>Architecture</h4>
                                    </FadeType>
                                    {testimonialData
                                        .filter((val) => val.type === "architecture")
                                        .map((val, index) => (
                                            <FadeType type="down" delay={index * 0.1} key={index}>
                                                <p
                                                    className={val.id === testimonialId ? styles.testimonial_highlight : undefined}
                                                    onMouseOver={() => setTestimonialId(val.id)}
                                                    onMouseLeave={() => setIndex(0)}
                                                >
                                                    {val.head}
                                                </p>
                                            </FadeType>
                                        ))}
                                </div>
                                <div className={styles.testimonial_box}>
                                    <FadeType type="up">
                                        <h4>Workshop</h4>
                                    </FadeType>
                                    {testimonialData
                                        .filter((val) => val.type === "workshop")
                                        .map((val, index) => (
                                            <FadeType type="down" delay={index * 0.1} key={index}>
                                                <p
                                                    className={val.id === testimonialId ? styles.testimonial_highlight : undefined}
                                                    onMouseOver={() => setTestimonialId(val.id)}
                                                    onMouseLeave={() => setIndex(0)}
                                                >
                                                    {val.head}
                                                </p>
                                            </FadeType>
                                        ))}
                                </div>
                                <div className={styles.testimonial_box}>
                                    <FadeType type="up">
                                        <h4>Stay</h4>
                                    </FadeType>
                                    {testimonialData
                                        .filter((val) => val.type === "stay")
                                        .map((val, index) => (
                                            <FadeType type="down" delay={index * 0.1} key={index}>
                                                <p className={val.id === testimonialId ? styles.testimonial_highlight : undefined}
                                                    onMouseOver={() => setTestimonialId(val.id)}
                                                    onMouseLeave={() => setIndex(0)}
                                                >
                                                    {val.head}
                                                </p>
                                            </FadeType>
                                        ))}
                                </div>
                                <div className={styles.testimonial_box}>
                                    <FadeType type="up">
                                        <h4>Experiences</h4>
                                    </FadeType>
                                    {testimonialData
                                        .filter((val) => val.type === "experience")
                                        .map((val, index) => (
                                            <FadeType type="down" delay={index * 0.1} key={index}>
                                                <p
                                                    className={val.id === testimonialId ? styles.testimonial_highlight : undefined}
                                                    onMouseOver={() => setTestimonialId(val.id)}
                                                    onMouseLeave={() => setIndex(0)}
                                                >
                                                    {val.head}
                                                </p>
                                            </FadeType>
                                        ))}
                                </div>
                            </div>
                            <div className={styles.testimonial_quote_container} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
                                <div className={styles.quote_container}>
                                    {testimonialData
                                        .filter((val) => val.id === testimonialId)
                                        .map((val, index) => (
                                            <FadeType wrapperElement="p" type="left" key={val.id}>
                                                {val.body1}
                                                {val.body2 && <>
                                                    <br />
                                                    <br />
                                                    {val.body2}
                                                </>}
                                                {val.body3 && <>
                                                    <br />
                                                    <br />
                                                    {val.body3}
                                                </>}
                                                {val.body4 && <>
                                                    <br />
                                                    <br />
                                                    {val.body4}
                                                </>}
                                            </FadeType>
                                        ))}
                                </div>
                                {testimonialData
                                    .filter((val) => val.id === testimonialId)
                                    .map((val, index) => (
                                        <div className={styles.author} key={val.id}>
                                            <FadeType wrapperElement="h4" type="right">
                                                {val.name}
                                            </FadeType>
                                            <FadeType wrapperElement="p" type="down" delay={0.1}>
                                                {val.caption1}
                                            </FadeType>
                                            {/* <FadeType wrapperElement="p" type="down">
                                            {val.caption2}
                                        </FadeType> */}
                                        </div>
                                    ))}
                            </div>
                        </>
                    )}
                </div>
                {/* <div className={styles.home_section___six}></div> */}
                <div className={styles.home_section___five}>
                    <FadeType type="left">
                        <h2>Get in touch</h2>
                    </FadeType>
                    <div className={styles.form_grid}>
                        <form
                            onSubmit={handleSubmit}
                            className={styles.home_form}
                        >
                            <div className={styles.form_content_grid}>
                                <div className={styles.form_input_box}>
                                    <FadeType
                                        type="left"
                                        className={styles.input_name_row}
                                    >
                                        <div
                                            className={`${styles.input_error_box
                                                } ${errorFlag &&
                                                errorId === "name" &&
                                                styles.error_highlight
                                                }`}
                                        >
                                            <input
                                                placeholder="What is your name?"
                                                type="text"
                                                name="name"
                                                id="name"
                                                value={name}
                                                onChange={handleFormDataChange}
                                            />
                                            {errorFlag &&
                                                errorId === "name" && (
                                                    <p>{message}</p>
                                                )}
                                        </div>
                                        <div
                                            className={`${styles.input_error_box
                                                } ${errorFlag &&
                                                errorId === "mobileNo" &&
                                                styles.error_highlight
                                                }`}
                                        >
                                            <input
                                                placeholder="Mobile No."
                                                type="number"
                                                name="mobileNo"
                                                id="mobileNo"
                                                value={mobileNo}
                                                onChange={handleFormDataChange}
                                            />
                                            {errorFlag &&
                                                errorId === "mobileNo" && (
                                                    <p>{message}</p>
                                                )}
                                        </div>
                                    </FadeType>
                                    <FadeType
                                        type="left"
                                        className={`${styles.input_error_box} ${errorFlag &&
                                            errorId === "email" &&
                                            styles.error_highlight
                                            }`}
                                    >
                                        <input
                                            placeholder="Email Address"
                                            type="email"
                                            name="email"
                                            id="email"
                                            value={email}
                                            onChange={handleFormDataChange}
                                        />
                                        {errorFlag && errorId === "email" && (
                                            <p>{message}</p>
                                        )}
                                    </FadeType>
                                    <FadeType
                                        type="left"
                                        className={`${styles.input_error_box} ${errorFlag &&
                                            errorId === "helpMessage" &&
                                            styles.error_highlight
                                            }`}
                                    >
                                        <input
                                            placeholder="How can we help you?"
                                            type="text"
                                            name="helpMessage"
                                            id="help"
                                            value={helpMessage}
                                            onChange={handleFormDataChange}
                                        />
                                        {errorFlag &&
                                            errorId === "helpMessage" && (
                                                <p>{message}</p>
                                            )}
                                    </FadeType>
                                    {/* <FadeType type="left">
                                        <label>
                                            <input
                                                type="checkbox"
                                                name="subscription"
                                                checked={checkBoxValue}
                                                onChange={() =>
                                                    setCheckBoxValue(
                                                        !checkBoxValue
                                                    )
                                                }
                                            />
                                            <span>Subscribe to newsletter</span>
                                        </label>
                                    </FadeType> */}
                                </div>
                                <FadeType
                                    type="right"
                                    className={styles.form_grid___content}
                                >
                                    <p>
                                        We are almost always available except
                                        when we are not. Feel free to e-mail us
                                        regarding any question or inquiry in
                                        detail.
                                    </p>
                                    <a
                                        href={"mailto:hello@north.in"}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <h4 className="email_text_dark">
                                            hello@north.in
                                        </h4>
                                    </a>
                                </FadeType>
                            </div>
                            <FadeType type="down">
                                <button
                                    type="submit"
                                    className="normal_btn___light"
                                >
                                    Send
                                </button>
                            </FadeType>
                        </form>
                    </div>
                </div>
                <FooterWithContactUs />
            </div>
        </>
    );
};

export default HomePageComp;
